import { render } from "./NewDocumentsCard.vue?vue&type=template&id=7aa212bc&scoped=true"
import script from "./NewDocumentsCard.vue?vue&type=script&lang=js"
export * from "./NewDocumentsCard.vue?vue&type=script&lang=js"

import "./NewDocumentsCard.vue?vue&type=style&index=0&id=7aa212bc&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa212bc"]])

export default __exports__